export default __webpack_public_path__ + "images/new-modal-delete-icon.svg";